import React from 'react';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import ContractDetailContainer from './ContractDetailContainer';

const ContractDetailScene = (props) => (
  <>
    <Breadcrumb
      crumbs={[
        ...(props.location.state && props.location.state.from
          ? [{ text: props.location.state.from.text, link: props.location.state.from.pathname }]
          : []),
        {
          text: 'Contract Detail',
        },
      ]}
    />
    <ContractDetailContainer contractId={props.params.contractId} />
  </>
);

export default ContractDetailScene;
